// // import React from "react";
// // import "./Hero.css";
// // import hero_image from "../Assets/hero_image.png";
// // import hand_icon from "../Assets/hand_icon.png";
// // import arrow_icon from "../Assets/arrow.png";

// // const Hero = () => {
// //   return (
// //     <div className="hero">
// //       <div className="hero-left">
// //         <h2>NEW ARRIVALS ONLY</h2>
// //         <div>
// //           <div className="hero-hand-icon">
// //             <p>new</p>
// //             <img src={hand_icon} alt="" />
// //           </div>
// //           <p>collections</p>
// //           <p>for everyone</p>
// //         </div>
// //         <div className="hero-latest-btn">
// //           <div>Latest Collection</div>
// //           <img src={arrow_icon} alt="" />
// //         </div>
// //       </div>
// //       <div className="hero-right">
// //         <img src={hero_image} alt="hero" />
// //       </div>
// //     </div>
// //   );
// // };

// // export default Hero;


// import React from "react";
// import "./Hero.css";
// // import hero_image from "../Assets/hero.jpg"; // you can later replace with tech image
// import arrow_icon from "../Assets/arrow.png";

// const Hero = () => {
//   return (
//     <div className="hero">
//       {/* LEFT */}
//       <div className="hero-left">
//         <h2>TECH & MEDIA PLATFORM</h2>

//         <h1>
//           Stay Ahead in <span>Technology</span>
//         </h1>

//         <p>
//           Latest insights on Media Production tools and Templates, AI, Software Development, Production tutorials, and Digital Media.
//         </p>

//         <div className="hero-buttons">
//           <button className="primary-btn">
//             Learn More <img src={arrow_icon} alt="" />
//           </button>

//           {/* <button className="secondary-btn">
//             Watch Videos
//           </button> */}
//         </div>
//       </div>

//       {/* RIGHT */}
//       <div className="hero-right">
//         {/* <img src={hero_image} alt="hero" /> */}
//       </div>
//     </div>
//   );
// };

// export default Hero;


import React from "react";
import "./Hero.css";
import arrow_icon from "../Assets/arrow.png";

// ✅ Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

// ✅ Your images
import hero1 from "../Assets/hero.jpg";
import hero2 from "../Assets/hero.jpg"; // add more images
import hero3 from "../Assets/hero.jpg";

const Hero = () => {
  return (
    <div className="hero">
      
      {/* 🔥 BACKGROUND SLIDER */}
      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        className="hero-swiper"
      >
        <SwiperSlide>
          <img src={hero1} alt="slide1" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={hero2} alt="slide2" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={hero3} alt="slide3" />
        </SwiperSlide>
      </Swiper>

      {/* 🔥 CONTENT OVERLAY */}
      <div className="hero-content">
        <div className="hero-left">
          <h2>TECH & MEDIA PLATFORM</h2>

          <h1>
            Stay Ahead in <span>Technology</span>
          </h1>

          {/* <p>
            Latest insights on Media Production tools and Templates, AI,
            Software Development, Production tutorials, and Digital Media.
          </p> */}

          <div className="hero-buttons">
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;